<template>
  <div class="form-item-container" :class="{ 'first-form-item': form_item_order === 0 && layout_mode === 'all_on_one_page' }">
    <div class="questions-container">
      <div class="question-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="question-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>
    <div class="response-container">
      <div class="cursor-pointer" v-for="star in maxStars" :key="star" @click="handleClick(star)">
        <img v-if="star === 1" :src="(getCurrentRating) >= star ? starOnIcon : starOffIcon" />
        <img v-if="star === 2" :src="(getCurrentRating) >= star ? starOnIcon : starOffIcon" />
        <img v-if="star === 3" :src="(getCurrentRating) >= star ? starOnIcon : starOffIcon" />
        <img v-if="star === 4" :src="(getCurrentRating) >= star ? starOnIcon : starOffIcon" />
        <img v-if="star === 5" :src="(getCurrentRating) >= star ? starOnIcon : starOffIcon" />
        <div>{{ getDefaultStarLabel(star) }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import starOffIcon from '@/assets/icons/star-off.svg'
import starOnIcon from '@/assets/icons/star-on.svg'

export default defineComponent({
  name: 'RatingStars',
  props: {
    initialRating: {
      type: Number,
      default: 0
    },
    maxStars: {
      type: Number,
      default: 5
    },
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    form_item_id: {
      type: Number,
      default: 0
    },
    form_item_order: {
      type: Number,
      default: -1
    },
    layout_mode: {
      type: String,
      default: 'all_on_one_page'
    }
  },
  data () {
    return {
      starOffIcon,
      starOnIcon,
      currentRating: this.initialRating
    }
  },
  computed: {
    getCurrentRating (): number {
      return this.currentRating
    }
  },
  methods: {
    handleClick (rating: number) {
      this.currentRating = rating
      this.$emit('response-submitted', rating.toString())
    },
    getDefaultStarLabel (star: number) {
      switch (star) {
        case 1:
          return 'Muito mau'
        case 2:
          return 'Mau'
        case 3:
          return 'Médio'
        case 4:
          return 'Bom'
        case 5:
          return 'Muito bom'
        default:
          return ''
      }
    },
    getStarLabel (star: number) {
      switch (star) {
        case 1:
          return 'Muito mau'
        case 2:
          return 'Mau'
        case 3:
          return 'Médio'
        case 4:
          return 'Bom'
        case 5:
          return 'Muito bom'
        default:
          return ''
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.form-item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  padding: 2em 5% 2em 5%;
  color: $gorate-secondary;

  .questions-container {
    grid-row: 1;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    align-items: center;
    justify-items: center;

    .question-primary-language {
      grid-row: 1;
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .question-secondary-language {
      grid-row: 2;
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

  .response-container {
    /* display: flex; */
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 2em;
    justify-content: center;
    padding: 1em 0em;

    img {
      width: 5em;
    }
  }
}

@media (max-width: 1024px) {
  .form-item-container {
    .response-container {
      display: flex;
      gap: 0em;
      justify-content: center;
      padding: 1em 0em;

      div img {
        /* width: 120px; */
        max-width: 70%;
      }
    }
  }

  .rating-caption {
    display: none;
  }
}

.rating-caption {
  font-size: 1.5em;
  text-align: center;
  min-width: 4em;
}

.star-container {
  padding: 0 32px;
}

.cursor-pointer {
  cursor: pointer;
  text-align: center;
}
</style>
